import { PageData } from '../../../../_metronic/helpers/utils/types';
import { getIdealImageSize } from '../../../../_metronic/helpers/utils/utils';
export const footerData: PageData = [
  {
    formId: 'form1',
    heading: 'Footer Section',
    data: [
      { id: 'title', label: 'Title', type: 'input' },
      { id: 'joinButtonText', label: 'Join now button text', type: 'input' },
      { id: 'joinButtonLink', label: 'Join now button link', type: 'input' },
      { id: 'contactButtonText', label: 'Contact us button text', type: 'input' },
      { id: 'contactButtonLink', label: 'Contact us button link', type: 'input' },
      { id: 'logo', label: 'Company logo', info: getIdealImageSize(186, 50), type: 'image', backgroundColor:'#000' },
      { id: 'location', label: 'Location name', type: 'input' },
      { id: 'address', label: 'Location address', type: 'textarea' },
      { id: 'copyright', label: 'Copyright text', type: 'input' },
      { id: 'meetingTitle', label: 'Book meeting text', type: 'input' },
      {
        id: 'calendlyLogo',
        label: 'Calendly logo',
        info: getIdealImageSize(39, 38),
        type: 'image'
      },
      { id: 'calendlyText', label: 'Text inside calendly', type: 'input' },
      { id: 'calendlyLink', label: 'Calendly link', type: 'input' }
    ]
  },
  {
    formId: 'formGroup1',
    heading: 'Footer links (first column)',
    data: [
      { id: 'footerText', label: 'Footer link text', type: 'input' },
      { id: 'footerLink', label: 'Footer link URL', type: 'input' }
    ]
  },
  {
    formId: 'formGroup2',
    heading: 'Footer links (second column)',
    data: [
      { id: 'footerText', label: 'Footer link text', type: 'input' },
      { id: 'footerLink', label: 'Footer link URL', type: 'input' }
    ]
  }
];
